import React from 'react'
import { useTranslation } from 'react-i18next'
import { Question } from '../input/store-input'
import { EditableMessage, EditableMessageList } from '../../components/editable-message-list'

type QuestionsListProps = {
    value?: Question[]
    onChange?: (value: Question[]) => void
    addButtonText?: string
    placeholder?: string
    className?: string
    showAutoReject?: boolean
    max?: number
    maxLength?: number
}

export function QuestionsList({
    value = [],
    onChange,
    addButtonText,
    placeholder,
    className,
    showAutoReject = true,
    max,
    maxLength,
}: QuestionsListProps) {
    const { t } = useTranslation()

    const editableMessages: EditableMessage[] = value.map((question: Question, index: number) => ({
        id: index.toString(),
        text: question.text,
        autoReject: question.autoReject,
    }))

    const handleChange = (messages: EditableMessage[]) => {
        const questions: Question[] = messages.map((msg) => ({
            text: msg.text,
            autoReject: msg.autoReject || false,
        }))

        onChange?.(questions)
    }

    return (
        <EditableMessageList
            messages={editableMessages}
            onChange={handleChange}
            addButtonText={addButtonText || t('Add question')}
            placeholder={placeholder || t('Enter question')}
            className={className}
            showAutoReject={showAutoReject}
            max={max}
            maxLength={maxLength}
        />
    )
}
